export default __webpack_public_path__ + "static/media/iceCrackedHolo.9a92b3f3.svg";